<template lang="pug">
.container-top-habilidades
  .label Top 3 Habilidades
  .corpo
    .posicao-habilidades(v-for="(item, i) in form" :key="`position-${i}-${item.habilidade || 'empty'}`")
      .header
        .posicao {{ i+1 }}°
          span Posição
        .selecao-cor
          SelectPadrao(:options="getCores" v-model="item.corSelecionada")
      .form
        el-form(class="form-custom-nexa" :model="item" :ref="`formRef${i}`" label-width="100px")
          //- el-form-item(label="Nome da Habilidade")
          //-   el-input(v-model="item.habilidade" placeholder="Sua habilidade")
        .selecao-habilidade
          SelectPadrao(
            :options="getOpcoesDisponiveis(i)" 
            v-model="item.habilidade" 
            label="Nome da Habilidade"
            clearable
            @input="atualizarNivelPorHabilidade(i, $event)"
          )
      .visualizacao
        .label-visualizacao Visualização
        .area-visualizacao(:key="`viz-${i}-${item.habilidade}-${item.nivel}`")
          .estrelas
            Stars(
              :key="`stars-${i}-${item.nivel}-${item.corSelecionada}`"
              :size="16" 
              :filled="getNivelStar(item.nivel)" 
              :filledColor="getCorHex(item.corSelecionada)"
            )
          .habilidade {{ item.habilidadeNome || getHabilidadeNome(item.habilidade) }}
          .posicao {{ i+1 }}° lugar
  .btn-salvar
    ButtonPadrao(iconLeft @click="salvarAlteracoes" :loading="salvando")
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import SelectPadrao from '@/components/ui/SelectPadrao.vue'
import Stars from '@/components/ui/Stars.vue'
import MessageMixin from '@/mixins/MessageMixin'

export default {
  name: 'TopHabilidades',
  mixins: [MessageMixin],
  components: {
    ButtonPadrao,
    SelectPadrao,
    Stars
  },

  computed: {
    ...mapGetters({
      getCores: 'habilidades/cores',
      getNiveis: 'habilidades/niveis',
      getTodasHabilidades: 'habilidades/todasHabilidades'
    }),

    // Retorna opções disponíveis para cada posição, excluindo as já selecionadas
    getOpcoesDisponiveis() {
      return (index) => {
        const habilidadeSelecionadaNestaPosicao = this.form[index]?.habilidade
        
        const habilidadesSelecionadas = this.form
          .map((item, i) => i !== index ? item.habilidade : null)
          .filter(h => h !== null && h !== '')
        
        return this.getTodasHabilidades.filter(h => {
          // Sempre inclui a habilidade atualmente selecionada nesta posição
          if (h.value === habilidadeSelecionadaNestaPosicao) {
            return true
          }
          
          // Exclui habilidades já selecionadas em outras posições
          if (habilidadesSelecionadas.includes(h.value)) {
            return false
          }
          
          // Exclui habilidades com ID temporário e sem label válido
          if (typeof h.value === 'string' && h.value.startsWith('temp-')) {
            // Se o label também começa com temp ou está vazio, exclui
            if (!h.label || h.label.startsWith('temp-') || h.label.trim() === '') {
              return false
            }
          }
          
          return true
        })
      }
    }
  },

  data() {
    return {
      salvando: false,
      form: [
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          habilidadeNome: '',
          nivel: '',
        },
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          habilidadeNome: '',
          nivel: ''
        },
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          habilidadeNome: '',
          nivel: ''
        },
      ]
    }
  },

  mounted() {
    this.carregarTopHabilidades()
  },

  watch: {
    form: {
      handler(newVal) {
        this.$store.dispatch('perfil/atualizarTopHabilidades', newVal)
      },
      deep: true
    },
    '$store.state.auth.user': {
      handler(newUser) {
        if (newUser && newUser.top_habilidades) {
          this.carregarTopHabilidades()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    carregarTopHabilidades() {
      const userData = this.$store.state.auth.user
      
      if (userData && userData.top_habilidades && Array.isArray(userData.top_habilidades)) {
        // Ordena por posição
        const topOrdenadas = [...userData.top_habilidades].sort((a, b) => a.posicao - b.posicao)
        
        // Popula o form com as top 3 habilidades
        topOrdenadas.forEach((top, index) => {
          if (index < 3) {
            let habilidadeId = top.skill_id
            
            // Se o ID é temporário (começa com "temp-"), tenta encontrar a habilidade pelo nome
            if (typeof habilidadeId === 'string' && habilidadeId.startsWith('temp-')) {
              const habilidadePorNome = this.getTodasHabilidades.find(h => h.label === top.name)
              if (habilidadePorNome) {
                habilidadeId = habilidadePorNome.value
              } else {
                // Se não encontrou, deixa vazio para o usuário selecionar novamente
                habilidadeId = ''
              }
            }
            
            this.form[index] = {
              corSelecionada: top.cor || 'Amarelo',
              habilidade: habilidadeId,
              habilidadeNome: top.name,
              nivel: top.nivel
            }
          }
        })
      }
    },
    getHabilidadeNome(habilidadeValue) {
      // Se for vazio, retorna vazio
      if (!habilidadeValue) return ''
      
      // Tenta encontrar pelo value
      const habilidade = this.getTodasHabilidades.find(h => h.value === habilidadeValue)
      if (habilidade) {
        return habilidade.label
      }
      
      // Se não encontrou e é um ID temporário, retorna vazio
      if (typeof habilidadeValue === 'string' && habilidadeValue.startsWith('temp-')) {
        return ''
      }
      
      return habilidadeValue
    },
    atualizarNivelPorHabilidade(index, habilidadeSelecionada) {
      console.log('=== Atualizando habilidade ===')
      console.log('Index:', index)
      console.log('Valor selecionado:', habilidadeSelecionada)
      console.log('Form antes:', JSON.parse(JSON.stringify(this.form[index])))
      
      const habilidadeEncontrada = this.getTodasHabilidades.find(h => h.value === habilidadeSelecionada)
      
      if (habilidadeEncontrada) {
        console.log('Habilidade encontrada:', habilidadeEncontrada)
        // Atualiza todos os campos usando $set para garantir reatividade
        this.$set(this.form[index], 'habilidade', habilidadeSelecionada)
        this.$set(this.form[index], 'nivel', habilidadeEncontrada.nivel)
        this.$set(this.form[index], 'habilidadeNome', habilidadeEncontrada.label)
        
        // Força atualização da visualização
        this.$forceUpdate()
        
        this.$nextTick(() => {
          console.log('Form depois:', JSON.parse(JSON.stringify(this.form[index])))
        })
      } else {
        console.log('Habilidade não encontrada - limpando campos')
        // Se a habilidade não foi encontrada (clearable), limpa os campos
        this.$set(this.form[index], 'habilidade', '')
        this.$set(this.form[index], 'nivel', '')
        this.$set(this.form[index], 'habilidadeNome', '')
        this.$forceUpdate()
      }
    },
    getCorHex(cor) {
      switch (cor) {
        case 'Amarelo':
          return '#facc15'
        case 'Azul':
          return '#60a5fa'
        case 'Roxo':
          return '#c084fc'
        case 'Verde':
          return '#4ade80'
        case 'Vermelho':
          return '#f87171'
        case 'Rosa':
          return '#f472b6'
        default:
          return '#facc15'
      }
    },
    getNivelStar(nivel){
      switch (nivel) {
        case 'Iniciando':
          return 0
        case 'Aprendiz':
          return 1
        case 'Praticante':
          return 2
        case 'Profissional':
          return 3
        case 'Professor':
          return 4
        case 'Mestre':
          return 5
        default:
          return 0
      }
    },
    async salvarAlteracoes() {
      const user = JSON.parse(localStorage.getItem('user-nexa')) || {}
      const userId = user.id || 0
      
      if (!userId) {
        this.showErrorMessage('Usuário não identificado')
        return
      }
      
      this.salvando = true
      
      // Filtra habilidades preenchidas
      const topHabilidades = this.form
        .filter(item => item.habilidade && item.habilidade !== '')
        .map((item, index) => ({
          id: item.habilidade,
          posicao: index + 1,
          habilidade_id: item.habilidade,
          nivel: item.nivel,
          cor: item.corSelecionada,
          cor_hex: this.getCorHex(item.corSelecionada),
          estrelas: this.getNivelStar(item.nivel)
        }))
      
      if (topHabilidades.length === 0) {
        this.showWarningMessage('Selecione pelo menos uma habilidade')
        return
      }
      
      const payload = {
        usuario_id: userId,
        top_habilidades: topHabilidades
      }
      
      try {
        const result = await this.$store.dispatch('usuarioSkills/addTopSkills', payload)
        
        if (result.success) {
          this.showSuccessMessage('Top 3 habilidades salvas com sucesso!')
          
          // Atualiza os dados do usuário
          await this.$store.dispatch('usuario/fetchUsuarioById', userId)
        } else {
          this.showErrorMessage(result.error || 'Erro ao salvar top habilidades')
        }
        
      } catch (error) {
        console.error('Erro ao salvar top habilidades:', error)
        this.showErrorMessage('Erro ao salvar top habilidades')
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>


<style lang="scss">
.container-top-habilidades{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .label{
    font-size: 20px;
    font-weight: 700;
    color: $corVerdeClaro;
    padding: 24px;
  }
  .corpo{
    padding: 0 24px 24px;

    .posicao-habilidades{
      border: 1px solid $borderColor;
      border-radius: 8px;
      background: $corPreto;
      padding: 16px;

      &:not(:last-child){
        margin-bottom: 24px;
      }

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .posicao{
          font-size: 16px;
          font-weight: 700;
          color: $corVerdeClaro;

          span{
            color: #fff;
            font-weight: 500;
            padding-left: 5px;
          }
        }
        .selecao-cor{
          width: 120px;
        }
      }
      .form{
        width: 100%;

        .selecao-habilidade{
          .select-container{
            .el-select{
              width: 100%;

              .el-input{
                .el-input__inner{
                  background: #000;
                }
              }
            }
          }
        }
      }

      .visualizacao{
        margin-top: 16px;

        .label-visualizacao{
          text-align: left;
          color: #9ca3af;
          line-height: 30px;
          font-size: 14px;
        }
        .area-visualizacao{
          background: $corFundoPadraoDashboard;
          border: 1px solid $borderColor;
          padding: 12px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 8px;

          .estrelas{
            margin-bottom: 8px;
          }

          .habilidade{
            font-size: 14px;
            color: $corBranco;
            font-weight: 500;
          }
          .posicao{
            font-size: 12px;
            color: $corValueInfoContato;
            font-weight: 400;
            margin-top: 4px;
          }
        }
      }
    }


  }

  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .btn-salvar{
      justify-content: center;
    }
  }
}
</style>